<template>
  <nav class="breadcrumb-play" aria-label="breadcrumb">
    <button
      v-if="showBack"
      type="button"
      class="breadcrumb-play__back"
      :aria-label="backLabel"
      @click="emit('back')"
    >
      <IconGoogle name="chevron_left" size="1.1rem" color="var(--fontcolor)" />
    </button>

    <ol class="breadcrumb-play__list">
      <li
        v-for="(item, index) in items"
        :key="index"
        class="breadcrumb-play__item"
      >
        <IconGoogle
          v-if="index > 0"
          name="chevron_right"
          size="0.75rem"
          color="var(--text-color)"
          class="breadcrumb-play__separator"
        />
        <component
          :is="isClickable(item, index) ? 'router-link' : 'span'"
          v-bind="isClickable(item, index) ? { to: item.path } : {}"
          class="breadcrumb-play__label"
          :class="{
            'breadcrumb-play__label--active': index === items.length - 1,
            'breadcrumb-play__label--link': isClickable(item, index),
          }"
        >
          {{ item.name }}
        </component>
      </li>
    </ol>
  </nav>
</template>

<script lang="ts" setup>
import { IconGoogle } from '@/components/atomic'
import { RouterLink as _RouterLink } from 'vue-router'

export interface BreadcrumbItem {
  name: string
  path?: string
}

const props = withDefaults(defineProps<{
  items: BreadcrumbItem[]
  showBack?: boolean
  backLabel?: string
}>(), {
  showBack: true,
  backLabel: 'Voltar',
})

const emit = defineEmits<{
  back: []
}>()

function isClickable(item: BreadcrumbItem, index: number): boolean {
  return !!item.path && item.path !== '#' && index !== props.items.length - 1
}
</script>

<style lang="scss" scoped>
.breadcrumb-play {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.breadcrumb-play__back {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;

  &:hover {
    background: var(--layout-background-color);
  }
}

.breadcrumb-play__list {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  list-style: none;
  margin: 0;
  padding: 0;
  flex: 1;
  min-width: 0;
}

.breadcrumb-play__item {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  min-width: 0;
}

.breadcrumb-play__separator {
  flex-shrink: 0;
}

.breadcrumb-play__label {
  font-size: 0.875rem;
  line-height: 1.25;
  color: var(--text-color);
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &--active {
    color: var(--fontcolor);
    font-weight: 600;
  }

  &--link {
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
